// extracted by mini-css-extract-plugin
export default {"header":"KE","discountBanner":"LE","logo":"ME","maincontainer":"NE","videocontainer":"OE","videowelcome":"PE","videowrapper":"QE","videosale":"RE","loadingcontainer":"SE","footer":"TE","footerbutton":"UE","video":"VE","logoname":"WE"};
    if(module.hot) {
      // 1715091679212
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  